<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{ $route.meta.title }}</span>
      </div>
    </div>

    <Card :bordered="false" dis-hover class="ivu-mt">

      <Table :columns="columns" stripe :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

        <template slot-scope="{ row, index }" slot="action">
          <a @click="player(row)">播放</a>
        </template>

      </Table>
    </Card>

    <!--  播放弹窗-->
    <Modal
      v-model="playerShow"
      :title="playerTitle || '播放'"
      ok-text="关闭"
      cancel-text=""
      width="70"
    >
      <div>
        <AliyunPlayer :url="playerUrl"></AliyunPlayer>
      </div>
    </Modal>

  </div>
</template>

<script>
import {plantDeviceMonitoringListApi} from '@/api/plant/plantDevice'
import AliyunPlayer from '_c/AliyunPlayer'

export default {
  name: 'plantDeviceMonitoringList',
  components: {AliyunPlayer},
  inject: ['reload'],
  data() {
    return {
      playerShow: false,
      playerUrl: '',
      playerTitle: '',

      tableData: [],
      loading: false,
      columns: [
        {
          title: '所在基地',
          key: 'land_base_name',
          minWidth: 120
        },
        {
          title: '设备编号',
          key: 'device_sn',
          minWidth: 120
        },
        {
          title: '设备厂商',
          key: 'company',
          minWidth: 120
        },
        {
          title: '设备状态',
          minWidth: 120,
          render: (h, params) => {
            return h('span', '在线')
          }
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        },

      ]
    }
  },
  created() {
    this.loadTableData()
  },
  methods: {
    loadTableData() {
      this.loading = true
      plantDeviceMonitoringListApi().then(res => {
        this.tableData = res.data
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },

    // 播放
    player(row){
      this.playerUrl = row.values
      this.playerTitle = row.title
      this.playerShow = true
    },


  }
}
</script>
